"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeSubmissionSection = void 0;
const tslib_1 = require("tslib");
const renderSubmission_1 = require("./helpers/renderSubmission");
const defaultSubsections_1 = require("./helpers/defaultSubsections");
function makeSubmissionSection(db, section, patients, schema, start, end) {
    var _a, _b;
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const submissions = [];
        if ('action' in section) {
            const workflows = yield db.get.workflow.ongoingWorkflows.forUsers(section.workflow, patients === null || patients === void 0 ? void 0 : patients.map((patient) => patient._id));
            const workflowIds = workflows.map((workflow) => workflow._id);
            const workflowSubmissions = yield db.get.workflow.actions.byOngoingWorkflows(workflowIds, section.action, start, end);
            submissions.push(...workflowSubmissions);
        }
        else if ('form' in section) {
            const patientIds = patients.map((patient) => patient._id);
            const formSubmissions = yield db.get.form.submissions.forUsers(section.form, patientIds);
            submissions.push(...formSubmissions);
        }
        else {
            throw new Error(`Section provided to makeSubmissionSection did not provide an action nor a form`);
        }
        const subsections = {}; // Build up as a map, where the key is a subtitle and the value is the column
        for (const subsection of section.subsections) {
            subsections[subsection.subtitle] = yield makeSubsections(db, subsection, submissions, schema, (_a = section === null || section === void 0 ? void 0 : section.options) === null || _a === void 0 ? void 0 : _a.language);
        }
        const data = transformSubsectionsToDataArray(subsections); // Then, change it to an array of rows
        const descriptionObj = schema.schema.description;
        let localizedDescription = typeof descriptionObj === "string" ?
            (_b = schema.schema) === null || _b === void 0 ? void 0 : _b.description : descriptionObj === null || descriptionObj === void 0 ? void 0 : descriptionObj.en;
        localizedDescription = localizedDescription || schema.schema.title || 'Submission section';
        const description = section.description || (section.type === 'action' ?
            `Submissions to workflow action ${section.action} from workflow ${localizedDescription}`
            : `Submissions to form ${localizedDescription}`);
        return {
            data,
            type: section.type,
            title: section.title,
            description,
            subtitles: section.subsections.map((subsection) => subsection.subtitle),
        };
    });
}
exports.makeSubmissionSection = makeSubmissionSection;
function makeSubsections(db, subsection, submissions, schema, language) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        // Grab the function if this is a function subsection
        let func;
        if ('func' in subsection) {
            if (typeof subsection.func === 'function') {
                func = subsection.func;
            }
            else if (typeof subsection.func === 'string' &&
                defaultSubsections_1.default[subsection.func]) {
                func = defaultSubsections_1.default[subsection.func];
            }
        }
        // Iterate over the data and call the relevant method of grabbing data
        const subsectionData = [];
        for (const submission of submissions) {
            let data;
            if (func) {
                data = yield func(db, submission, schema);
            }
            else {
                data = (0, renderSubmission_1.renderSubmission)(schema.schema, submission, subsection, language);
            }
            data && subsectionData.push(data);
        }
        return subsectionData;
    });
}
function transformSubsectionsToDataArray(subsectionData) {
    const data = [];
    const entrySizes = Object.values(subsectionData).map((entries) => entries.length);
    const numEntries = Math.max(...entrySizes);
    for (let i = 0; i < numEntries; i++) {
        const entry = {};
        for (const subtitle of Object.keys(subsectionData)) {
            entry[subtitle] = subsectionData[subtitle][i];
        }
        data.push(entry);
    }
    return data;
}
//# sourceMappingURL=submissionSection.js.map